module.exports = __webpack_public_path__ + "img/tips.e2a39296.svg";